import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { alertActions, certapplyActions } from '../../../../store/actions'
import moment from 'moment'
import history from '../../../../route/history'
import { commons } from '../../../../hook/common'
import $ from 'jquery'

const CertApplyDetail = (props) => {
  const queryString = require('query-string')
  // let [state, setState] = useState(); => 사용 안해서 주석처리함 2022-05-04
  const [historyInfo, setHistoryInfo] = useState({})

  const [sumInfo, setSumInfo] = useState({
    totamtcur: '',
    count: 0,
    amount: 0,
  })

  const fileType = [
    { title: '수출신고필증', value: '811' },
    { title: 'Documentary credit(수출신용장)', value: '465' },
    { title: '외화표시 물품공급계약서', value: '2AN' },
  ]

  /**
   * 문서정보 조회
   */
  useEffect(() => {
    const locationInfo = props.location?.state

    if (!props.match.params.seq) {
      history.replace('/service/certmng')
      return
    }
    props.load(props.match.params.seq)

    setHistoryInfo({
      ...historyInfo,
      tabStatus: locationInfo?.tabStatus,
      selectedSubject: locationInfo?.selectedSubject,
      searchWord: locationInfo?.searchWord,
      srhFrom: locationInfo?.srhFrom,
      srhTo: locationInfo?.srhTo,
      srhKind: locationInfo?.srhKind,
      pageIdx: locationInfo?.pageIdx || 1,
    })
  }, [])

  let [step, setStep] = useState(1)

  /**
   * 문서 삭제 콜백
   */
  useEffect(() => {
    if (props.isDelete === true) {
      sessionStorage.removeItem(props.data?.step1?.docid)
      window.location.replace('/service/certmng')
    }
  }, [props.isDelete])

  useEffect(() => {
    if (props.data?.step1?.docid) {
      //임시저장 상태
      if (props.data?.step1.sts === '01') {
        history.replace('/service/certapply/1?seq=' + props.match.params.seq)
      } else {
        // setState(props.data); => 사용 안해서 주석처리함 2022-05-04
      }
    }
    changeSumInfo(props.data?.step2)
  }, [props.data])

  const onSelected = (value) => {
    setStep(value)
  }

  /**
   * 문서 삭제처리
   */
  const doDelete = () => {
    props.confirm({
      title: '확인',
      message: '문서를 삭제하시겠습니까?',
      params: {
        type: 'confirm',
        callback: () => {
          props.deleteDoc(props.data?.step1?.crtIssueSeq)
        },
      },
    })
  }

  const goList = () => {
    console.log('historyInfo', historyInfo)
    let paramStr = queryString.stringify(historyInfo)
    paramStr.length > 0 && (paramStr = '?' + paramStr)
    // history.push('/service/certmng' + paramStr)

    if (props.location.state === undefined) {
      console.log('1111111111', paramStr)
      history.push('/service/certmng', paramStr)
    } else {
      if (props.location.state.isHelp === undefined) {
        console.log('2222222222', paramStr)
        history.push('/service/certbox', paramStr)
      } else {
        console.log('3333333333', paramStr)
        history.push('/service/sent', paramStr)
      }
    }
  }

  const changeSumInfo = (list) => {
    let obj = sumInfo
    let cnt = 0
    let amt = 0

    list.map((item) => {
      item?.gramt && (amt += item.gramt)
      item?.grcnt && (cnt += item.grcnt)
    })

    setSumInfo({
      ...sumInfo,
      totamtcur: 'KRW',
      count: commons.addComma(cnt),
      amount: commons.addComma(amt),
    })
  }

  const toggleHandler = (e) => {
    e.preventDefault()
    $('.current-menu').toggleClass('on')
  }

  const selectNav = ({ target }) => {
    const { text } = target
    $('.current-menu').text(text).toggleClass('on')
  }

  return (
    <React.Fragment>
      {/* contents */}
      <div id="contents">
        <div className="content-header">
          <h2>구매확인서 신청내역 확인</h2>
          <div className="breadcrumb">
            <span>Home</span>
            <span>증명서 신청</span>
            <span>증명서 신청</span>
            <em>구매확인서 신청내역 확인</em>
          </div>
        </div>
        <h3 className="h3-tit mt30">정보</h3>
        <table className="tbl-view">
          <caption>전자문서번호, 수신처 (발급기관) 항목으로 구성</caption>
          <colgroup>
            <col className="col1" />
            <col />
          </colgroup>
          <tbody>
            <tr>
              <th scope="row">전자문서번호</th>
              <td>{props.data?.step1.docid}</td>
            </tr>
            <tr>
              <th scope="row">수신처 (발급기관)</th>
              <td>{props.data?.step1.issueNm}</td>
            </tr>
          </tbody>
        </table>
        <h3 className="h3-tit">일반정보</h3>
        <table className="tbl-view">
          <caption>신청인 정보, 상호, 성명, 사업자등록번호, 주소 항목으로 구성</caption>
          <colgroup>
            <col className="col1" />
            <col />
          </colgroup>
          <thead>
            <tr>
              <th scope="row" colSpan={2}>
                신청인 정보
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row" className="th01">
                상호
              </th>
              <td>{props.data?.step1.lctorgnm}</td>
            </tr>
            <tr>
              <th scope="row" className="th01">
                성명
              </th>
              <td>{props.data?.step1.lctceonm}</td>
            </tr>
            <tr>
              <th scope="row" className="th01">
                사업자등록번호
              </th>
              <td>{props.data?.step1.lctprtid}</td>
            </tr>
            <tr>
              <th scope="row" className="th01">
                주소
              </th>
              <td>
                {props.data?.step1.lctaddr1}
                <br />
                {props.data?.step1.lctaddr2} {props.data?.step1.lctaddr3}
              </td>
            </tr>
          </tbody>
        </table>
        <table className="tbl-view mt10">
          <caption>공급자 정보, 상호, 성명, 사업자등록번호, 주소 항목으로 구성</caption>
          <colgroup>
            <col className="col1" />
            <col />
          </colgroup>
          <thead>
            <tr>
              <th scope="row" colSpan={2}>
                공급자 정보
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row" className="th01">
                상호
              </th>
              <td>{props.data?.step1.splyCmpyNm}</td>
            </tr>
            <tr>
              <th scope="row" className="th01">
                성명
              </th>
              <td>{props.data?.step1.splynm}</td>
            </tr>
            <tr>
              <th scope="row" className="th01">
                사업자등록번호
              </th>
              <td>{props.data?.step1.splyprtnum}</td>
            </tr>
            <tr>
              <th scope="row" className="th01">
                주소
              </th>
              <td>
                {props.data?.step1.splyaddr1}
                <br />
                {props.data?.step1.splyaddr2} {props.data?.step1.splyaddr3}
              </td>
            </tr>
          </tbody>
        </table>
        <table className="tbl-view mt10">
          <caption>
            공급자에게 전자문서로 전달하는 경우 입력 (선택사항), 수발신인식별자, 상세수발신인식별자, 이메일주소 항목으로 구성
          </caption>
          <colgroup>
            <col className="col1" />
            <col />
          </colgroup>
          <thead>
            <tr>
              <th scope="row" colSpan={2}>
                ※공급자에게 전자문서로 전달하는 경우 입력 (선택사항)
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row" className="th01">
                수발신인식별자
              </th>
              <td>{props.data?.step1.splycd}</td>
            </tr>
            <tr>
              <th scope="row" className="th01">
                상세수발신인식별자
              </th>
              <td>{props.data?.step1.splyid}</td>
            </tr>
            <tr>
              <th scope="row" className="th01">
                이메일주소
              </th>
              <td>{props.data?.step1.emlAddr}</td>
            </tr>
          </tbody>
        </table>
        <div className="modal-cont mobile-scroll">
          <ul className="nav-tab tabs mt40">
            <li
              className={step === 1 ? 'on' : ''}
              onClick={() => {
                onSelected(1)
              }}
            >
              <a href="#buy-tab1">구매물품</a>
            </li>
            <li
              className={step === 2 ? 'on' : ''}
              onClick={() => {
                onSelected(2)
              }}
            >
              <a href="#buy-tab2">수출근거서류</a>
            </li>
            <li
              className={step === 3 ? 'on' : ''}
              onClick={() => {
                onSelected(3)
              }}
            >
              <a href="#buy-tab3">세금계산서</a>
            </li>
          </ul>
        </div>
        {/* mobile */}
        <div className="nav-wrap">
          <a className="current-menu" onClick={toggleHandler}>
            기관/법인 검색
          </a>
          <ul className="nav-menu">
            <li
              className={step === 1 ? 'on' : ''}
              onClick={() => {
                onSelected(1)
              }}
            >
              <a onClick={selectNav}>기관/법인 검색</a>
            </li>
            <li
              className={step === 2 ? 'on' : ''}
              onClick={() => {
                onSelected(2)
              }}
            >
              <a onClick={selectNav}>지갑 주소</a>
            </li>
            <li
              className={step === 3 ? 'on' : ''}
              onClick={() => {
                onSelected(3)
              }}
            >
              <a onClick={selectNav}>1회 열람</a>
            </li>
          </ul>
        </div>
        {/* //mobile */}
        <div className="tab-container">
          {step === 1 && (
            <div id="buy-tab1" className="tab-cont">
              <h3 className="h3-tit mt30">총 구매 물품</h3>
              <table className="tbl-view">
                <caption>총 수량, 총 금액 항목으로 구성</caption>
                <colgroup>
                  <col className="col1" />
                  <col />
                </colgroup>
                <tbody>
                  <tr>
                    <th scope="row">총 수량</th>
                    <td>{sumInfo?.count || ''}</td>
                  </tr>
                  <tr>
                    <th scope="row">총 금액</th>
                    <td>
                      {sumInfo?.amount || ''}
                      {sumInfo?.totamtcur || ''}
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="tbl-wrap mt20">
                <table className="tbl-list">
                  <caption>HS부호, 품명, 규격, 수량, 구매일, 단가, 금액 항목으로 구성</caption>
                  <colgroup>
                    <col style={{ width: '14%' }} />
                    <col style={{ width: '23%' }} />
                    <col style={{ width: '12%' }} />
                    <col style={{ width: '12%' }} />
                    <col style={{ width: '14%' }} />
                    <col style={{ width: '12%' }} />
                    <col />
                  </colgroup>
                  <thead>
                    <tr>
                      <th scope="col">HS부호</th>
                      <th scope="col">품명</th>
                      <th scope="col">규격</th>
                      <th scope="col">수량</th>
                      <th scope="col">구매일</th>
                      <th scope="col">단가</th>
                      <th scope="col">금액</th>
                    </tr>
                  </thead>
                  <tbody>
                    {props.data?.step2?.length > 0 ? (
                      props.data?.step2?.map((goods, index) => {
                        return (
                          <tr key={index}>
                            <td data-title={'HS부호'}>{goods.hsCd}</td>
                            <td data-title={'품명'}>{goods.itemnm}</td>
                            <td data-title={'규격'}>{goods.itemdeftxt}</td>
                            <td data-title={'수량'}>{goods.grcnt}</td>
                            <td data-title={'구매일'}>{moment(goods.crtYmd).format('YYYY-MM-DD')}</td>
                            <td data-title={'단가'}>{goods?.baseAmt && commons.addComma(goods.baseAmt)}</td>
                            <td data-title={'금액'}>{goods?.gramt && commons.addComma(goods.gramt)}</td>
                          </tr>
                        )
                      })
                    ) : (
                      <tr>
                        <td colSpan={7}>
                          <div className="nodata">검색된 자료가 없습니다.</div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          {step === 2 && (
            <div id="buy-tab2" className="tab-cont">
              <div className="tbl-wrap mt30">
                <table className="tbl-list">
                  <caption>근거서류명 및 번호, HS부호, 품명, 규격, 금액, 선적기일 항목으로 구성</caption>
                  <colgroup>
                    <col style={{ width: '17%' }} />
                    <col style={{ width: '14%' }} />
                    <col style={{ width: '25%' }} />
                    <col style={{ width: '14%' }} />
                    <col style={{ width: '14%' }} />
                    <col />
                  </colgroup>
                  <thead>
                    <tr>
                      <th scope="col">근거서류명 및 번호</th>
                      <th scope="col">HS부호</th>
                      <th scope="col">품명</th>
                      <th scope="col">규격</th>
                      <th scope="col">금액</th>
                      <th scope="col">선적기일</th>
                    </tr>
                  </thead>
                  <tbody>
                    {props.data?.step3?.length > 0 ? (
                      props.data?.step3?.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td data-title={'근거서류명 및 번호'}>
                              {
                                fileType.find((file) => {
                                  return file.value === item.fileCd
                                })?.title
                              }
                              [{item.fileNo}]
                            </td>
                            <td data-title={'HS부호'}>{item.hsCd}</td>
                            <td data-title={'품명'}>{item.itemnm}</td>
                            <td data-title={'규격'}>{item.itemdeftxt}</td>
                            <td data-title={'금액'}>
                              {item.totamtcur} {item?.amt && commons.addComma(item.amt)}
                            </td>
                            <td data-title={'선적기일'}>{moment(item.stngYmd).format('Y-M-D')}</td>
                          </tr>
                        )
                      })
                    ) : (
                      <tr>
                        <td colSpan={6}>
                          <div className="nodata">검색된 자료가 없습니다.</div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          {step === 3 && (
            <div id="buy-tab3" className="tab-cont">
              <div className="tbl-wrap mt30">
                <table className="tbl-list">
                  <caption>세금계산서번호, 품명, 규격, 공급가액, 세액, 수량, 선적기일 항목으로 구성</caption>
                  <colgroup>
                    <col style={{ width: '14%' }} />
                    <col style={{ width: '25%' }} />
                    <col style={{ width: '12%' }} />
                    <col style={{ width: '12%' }} />
                    <col style={{ width: '12%' }} />
                    <col style={{ width: '12%' }} />
                    <col />
                  </colgroup>
                  <thead>
                    <tr>
                      <th scope="col">세금계산서번호</th>
                      <th scope="col">품명</th>
                      <th scope="col">규격</th>
                      <th scope="col">공급가액</th>
                      <th scope="col">세액</th>
                      <th scope="col">수량</th>
                      <th scope="col">선적기일</th>
                    </tr>
                  </thead>
                  <tbody>
                    {props.data?.step4?.length > 0 ? (
                      props.data?.step4?.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td data-title={'세금계산서번호'}>
                              <span>{item.taxNo}</span>
                            </td>
                            <td data-title={'품명'}>
                              <span>{item.itemnm}</span>
                            </td>
                            <td data-title={'규격'}>
                              <span>{item.itemdeftxt}</span>
                            </td>
                            <td data-title={'공급가액'}>{item?.splyAmt && commons.addComma(item.splyAmt)}</td>
                            <td data-title={'세액'}>{item?.taxAmt && commons.addComma(item.taxAmt)}</td>
                            <td data-title={'수량'}>
                              {item?.itemqty && commons.addComma(item.itemqty)} {item.itemqtyunitcd}
                            </td>
                            <td data-title={'작성일자'}>{moment(item.writedt).format('Y-M-D')}</td>
                          </tr>
                        )
                      })
                    ) : (
                      <tr>
                        <td colSpan={7}>
                          <div className="nodata">검색된 자료가 없습니다.</div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
        <div className="list-footer">
          {props.data?.step1.sts === '04' && (
            <a
              href="#"
              className="btn-secondary md"
              onClick={(e) => {
                e.preventDefault()
                doDelete()
              }}
            >
              삭 제
            </a>
          )}
          <a
            href="#"
            className="btn-primary md"
            onClick={(e) => {
              e.preventDefault()
              goList()
            }}
          >
            목록으로
          </a>
        </div>
      </div>
      {/* //contents */}
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    data: state.certapply.data,
    isDelete: state.certapply.isDelete,
  }
}

const actionCreators = {
  load: certapplyActions.load,
  deleteDoc: certapplyActions.deleteTempDoc,
  confirm: alertActions.confirm,
}

export default connect(mapStateToProps, actionCreators)(CertApplyDetail)
